import React, { useEffect } from 'react';
import { useHistory, useLocation } from "react-router-dom";

const ConferenceSpeakerEventId = () => {
  const location = useLocation();
  const URL = window.location.href;
  const urlEventId = document.URL.split("/").slice(-1)[0];
  localStorage.removeItem('eventid');
  localStorage.removeItem('event_affiliation_source');
  localStorage.setItem('eventid', urlEventId);

  const history = useHistory();
  useEffect(() => {
    if (URL !== "") {
      history.push('/speaker-registration-form');
    }
  }, [URL, history]);

  return null;
};

export default ConferenceSpeakerEventId;